import React from 'react';
import PropTypes from 'prop-types';
import useFundsStateStore from './common/funds-state-hook';
import Hero from './funds-components/hero';
import TopRatedFundsSeriesHero from './funds-components/top-rated-funds-series-hero';
import IncomeSeriesHero from './funds-components/income-series-hero';
import Main from './funds-components/main';
import FundTypesModal from './funds-components/filter-components/fund-type-filter-components/fund-types-modal';

const INCOME_SERIES = 'income_series';
const TOP_RATED_FUNDS_SERIES = 'top_rated_funds_series';

export default function Funds(props) {
  const {
    showAssetClassFilterHint,
    searchNoResultsImageUrl,
    topRatedFundSeriesDesktopBackground,
    isCompany,
  } = props;
  const showHeroComponent = topRatedFundSeriesDesktopBackground !== '';
  const set = useFundsStateStore(state => state.set);
  set(state => {
    state.showAssetClassFilterHint = showAssetClassFilterHint;
    state.searchNoResultsImageUrl = searchNoResultsImageUrl;
  });

  const params = new URLSearchParams(window.location.search);
  const series = params.get('series');
  const isInTopRatedFundsSeries = series === TOP_RATED_FUNDS_SERIES;
  const isInIncomeSeries = series === INCOME_SERIES;
  const totalResults = useFundsStateStore(state => state.totalResults);
  const resultsText = totalResults !== null ? `${totalResults} Result${totalResults === 1 ? '' : 's'}` : null;
  document.querySelectorAll('span[role="__fund_hero_component_count"]').forEach(e => {
    e.innerHTML = resultsText;
  });
  // eslint-disable-next-line no-nested-ternary
  const HeroComponent = isInIncomeSeries
    ? <IncomeSeriesHero {...props} />
    : isInTopRatedFundsSeries
      ? <TopRatedFundsSeriesHero {...props} />
      : <Hero />;

  return (
    <React.Fragment>
      {!isCompany && !!showHeroComponent && HeroComponent}
      <Main {...props} />
      <FundTypesModal />
    </React.Fragment>
  );
}

Funds.propTypes = {
  showAssetClassFilterHint: PropTypes.bool.isRequired,
  searchNoResultsImageUrl: PropTypes.string.isRequired,
  topRatedFundSeriesDesktopBackground: PropTypes.string.isRequired,
  isCompany: PropTypes.bool.isRequired,
};
